<template>
  <div class="language-switcher">
    <h2 class="language-switcher__heading">
      {{ options.selectLanguage.title }}
    </h2>
    <div class="language-switcher__wrapper">
      <language-list
        v-for="item in options.selectLanguage.groups"
        :key="item.id"
        :lang="item"
      />
    </div>
  </div>
</template>

<script>
import languageList from './languageList.vue';

export default {
  name: 'popupLangs',
  components: {
    languageList,
  },
  computed: {
    options() {
      return this.$store.state.siteData;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../sass/setup.scss';

.language-switcher {
  padding: 62px 0 14px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @include up-tablet {
    padding: 93px 0;
  }

  @include up-desktop {
    padding: 161px 0 62px;
  }

  @include phone-landscape {
    padding: 26px 0;
  }

  &__heading {
    flex: none;
    margin: 0 auto 49px;
    max-width: 200px;
    font-family: $f-bellReg;
    font-size: 20px;
    line-height: 1.2;
    text-align: center;
    letter-spacing: 0.15px;

    @include up-tablet {
      max-width: unset;
      line-height: 3;
    }

    @include up-desktop {
      margin-bottom: 55px;
    }
  }

  &__wrapper {
    margin: 0 -16px;
    padding: 0 16px;
    flex-grow: 1;
    height: 100%;
    overflow-y: auto;
    scrollbar-color: #dbcbbd transparent;
    scrollbar-width: thin;

    @include up-tablet {
      margin: auto;
      width: fit-content;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 85px;
      grid-row-gap: 38px;
      min-height: 0;
      min-width: 0;
    }

    @include up-laptop {
      grid-template-columns: repeat(4, minmax(auto, 212px));
      grid-template-rows: auto 1fr;
    }

    @include up-desktop {
      padding: 0 30px;
      grid-column-gap: 12.29vw;
    }

    @media (min-width: 1440px) {
      grid-column-gap: 120px;
    }

    &::-webkit-scrollbar {
      width: 3px;
      height: 3px;
      background: rgba(227, 215, 203, 0.9);
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 0;
      background: linear-gradient(180deg, #f7ece2, rgba(247, 235, 225, 0));
    }
  }
}
</style>
